import { ClassicEditor } from 'ckeditor5'

import {
  CommentsConfig,
  ImageConfig,
  PlaceholderConfig,
  ToolbarConfig,
  TranslationsConfig,
} from '../../config'
import {
  CorePlugins,
  CustomPlugins,
  RealTimeCollaborationPlugins,
} from '../../plugins'
import { Context, ContextWatchdog } from './CustomContext'

import '../../custom.css'
import '@pbt/pbt-ui-components/src/index.css'

export class CustomClassicEditor extends ClassicEditor {
  // Plugins to include in the build.
  static builtinPlugins = [
    ...CorePlugins,
    ...CustomPlugins,
    ...RealTimeCollaborationPlugins,
  ]

  // Editor configuration.
  static defaultConfig = {
    ...CommentsConfig,
    ...ImageConfig,
    ...ToolbarConfig,
    ...PlaceholderConfig,
    ...TranslationsConfig,
  }
}

// The editor instance needs to be a default export in the editor bundle. UI consumes differently than CloudService
export default {
  CustomClassicEditor,
  Context,
  ContextWatchdog,
}
